import { render } from "./CustomersTab.vue?vue&type=template&id=50acb54d"
import script from "./CustomersTab.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomersTab.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Paywall/CustomersTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50acb54d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50acb54d', __exports__)) {
    api.reload('50acb54d', __exports__)
  }
  
  module.hot.accept("./CustomersTab.vue?vue&type=template&id=50acb54d", () => {
    api.rerender('50acb54d', render)
  })

}


export default __exports__